/**
 * Name:app.js 
 * Description:consists of redux store and the entire app.Get transpiled into bundle.js 1
 * 
 *  
 * */
import React from 'react';
import ReactDOM from 'react-dom';
import Routes from './components/Routes';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import reducers from './reducers'
import reduxThunk from 'redux-thunk';
import { PersistGate } from 'redux-persist/integration/react';
import storage from 'redux-persist/lib/storage'
import { persistStore, persistReducer } from 'redux-persist'

const persistConfig = {
  key: 'root',
  storage,
}
const persistedReducer = persistReducer(persistConfig, reducers)
let store = createStore(persistedReducer, {}, applyMiddleware(reduxThunk));
let persistor = persistStore(store)

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Routes />
    </PersistGate>
  </Provider>
  , document.getElementById('app'));


if (process.env.env != "stag") {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/service-worker.js')
        .then(registration => {
          console.log('SW registered: ', registration);
        }).catch(registrationError => {
          console.log('SW registration failed: ', registrationError);
        });
    });
  }
}